<template>
  <div>
    <b-overlay :show="fetching" opacity="0.6">
      <template #overlay>
        <div class="d-flex align-items-center">
          <b-spinner small type="grow" variant="secondary"></b-spinner>
          <b-spinner type="grow" variant="dark"></b-spinner>
          <b-spinner small type="grow" variant="secondary"></b-spinner>
          <!-- We add an SR only text for screen readers -->
          <span class="sr-only">Please wait...</span>
        </div>
      </template>
      <b-input-group :aria-hidden="fetching ? 'true' : null">
        <vue-multiselect
          v-model="currentInstance"
          :options="myInstances"
          :placeholder="$t('instances.select_instance')"
          track-by="id"
          label="name"
          :disabled="fetching"
          :allow-empty="false"
          :selectLabel="''"
          :deselectLabel="''"
          :selectedLabel="''"
          style="line-height: 1.4; max-width: 600px"
          @input="onSelect"
        ></vue-multiselect>
      </b-input-group>
    </b-overlay>
  </div>
</template>

<script>
import InstancesApi from "../../../apis/InstancesApi";

export default {
  props: {
    selectedInstance: Object,
    allowedPrograms: String,
    isAdmin: Number,
  },
  data() {
    return {
      fetching: false,
      currentInstance: null,
      instances: [],
      filteredPrograms: []
    };
  },
  computed: {
    myInstances() {
      return this.instances;
    },
  },
  created() {
    if (this.selectedInstance) {
      this.currentInstance = this.selectedInstance;
      //this.onSelect(this.selectedInstance);
    }
    this.getInstances();
  },
  methods: {
    getInstances() {
      this.fetching = true;
      InstancesApi.all({
        limit: 100000,
        orderBy: "name",
        returns: "id,name,attributes.messageTemplate.approvalProcessEnabled,attributes.messageTemplate.approvers",
        common: true,
      })
        .then((r) => {
          if (this.isAdmin) {
            this.instances = r.result;
          } else {
            this.filteredPrograms = JSON.parse(this.allowedPrograms);
            this.instances = r.result.filter(item_result => this.filteredPrograms.some(itemAllowed => itemAllowed.id === item_result.id));
          }
          this.fetching = false;
          // Auto select when only one instance enabled for the user
          if (!this.selectedInstance && this.myInstances.length == 1) {
            this.onSelect(this.myInstances[0]);
          }
        })
        .catch((e) => {
          this.fetching = false;
          this.$toast.error(
            "Error",
            this.$t("commons.unable_to_fetch_instances")
          );
        });
    },
    onSelect(e) {
      InstancesApi.setSelectedInstance({
        instance: e,
      })
        .then((r) => {
          const url = window.location.toString();
          const editIndex = url.indexOf("/edit");
          window.location.href = editIndex !== -1 ? url.substring(0, editIndex) : url;
        })
        .catch((e) => {
          this.$toast.error("Error", this.$t("instances.select_failed"));
        });
    },
  },
};
</script>

<style scoped>
.select-instance {
  min-width: 300px;
  max-width: 600px;
  line-height: 1.4;
}
</style>
